import * as yup from './yupSchemas';
import { userroles } from './user/check';

export { userroles, yup };

export const bgimage =
  'https://res.cloudinary.com/jadwalio/image/upload/v1683490337/%D9%84%D8%A7%D8%AA%D8%B1_%D9%87%D9%8A%D8%AF-1_uo3t0h.png';
// export const bgimage =
//   'https://res.cloudinary.com/jadwalio/image/upload/v1675412238/5487739_rsqkqi.jpg';
// export const bgimage =
//   'https://res.cloudinary.com/jadwalio/image/upload/v1675411838/bgimage_q3junm.jpg';

export const appversion = '1.11';
